export default "__VITE_ASSET__516f36d7__"